

import { Component, Mixins } from 'vue-property-decorator';
import PopupMixin from '~common-mixins/PopupMixin';
import { DevicesModule } from '~/store/modules/devices';
import DumpPopupMixin from '~/mixins/dumpPopup.mixin';

@Component
export default class OperationDumpLogsPopup extends Mixins(PopupMixin, DumpPopupMixin) {
    filePrefix = 'DumpLogs';

    get rawDumpValue() {
        return DevicesModule.dumpLogsValue;
    }

    async getDumpLogs() {
        try {
            const data = await DevicesModule.currentGateway?.dumpLogs();
            await DevicesModule.setDumpLogsValue(data);
        } catch (error) {
            await DevicesModule.setDumpLogsValue('Error while fetching dump logs');
        }
    }
}
